import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import NewClaimM from "./M/NewClaimM";
import { SysConfig } from "__SYSDefault/Config";
import NewClaimW from "./W/NewClaimW";

/**
 * @augments {Component<Props, State>}
 */
class NewClaim extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(NewClaim.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    return ResponsiveX.Split({
      0: () => <NewClaimM {...this.props} />,
      [SysConfig.WebUIWidth]: () => <NewClaimW {...this.props} />
    });
  }

}

export default observer(NewClaim);
